import App from './App';
import React from 'react';
import axios from "axios";
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {store , persistor} from "./store/index";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";

// axios.defaults.withCredentials = true;

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

axios.interceptors.response.use(function (response) {
  if(response.data?.error === 'Unauthenticated.') {
    sessionStorage.removeItem("persist:root");
    document.location.href = '/login';
    return Promise.reject(null);
  }
  return response;
}, function (error) {
  return error;
});

if ('serviceWorker' in navigator) {
  // The service worker can't read process.env, so pass the Firebase config
  // to it as query params; the SW reads them from its own registration URL.
  const firebaseParams = new URLSearchParams({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  });
  navigator.serviceWorker.register(`/firebase-messaging-sw.js?${firebaseParams.toString()}`)
  .then(function(registration) {
    console.log('Registration successful, scope is:', registration.scope);
  }).catch(function(err) {
    console.log('Service worker registration failed, error:', err);
  });
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
        <App />
    </PersistGate>
    </Provider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
